// extracted by mini-css-extract-plugin
export var copyableField = "_qb-4";
export var customerBadge = "_qb-0";
export var customerInfoTitle = "_qb-2";
export var details = "_qb-1";
export var dropdownContainer = "_qb-5";
export var dropdownImage = "_qb-6";
export var editAssigneeForm = "_qb-a";
export var editButton = "_qb-3";
export var email = "_qb-7";
export var hidden = "_qb-d";
export var input = "_qb-8";
export var saveButton = "_qb-b";
export var shopifyIcon = "_qb-c";
export var suggestionBadge = "_qb-e";
export var suggestionText = "_qb-f";
export var username = "_qb-9";